import classNames from 'classnames'
import React from 'react'
import { mainHeadingId } from 'App'
import { Button } from 'components/Button/Button'
import { IconPrint } from 'components/Icon/IconPrint'
import { useTranslation } from 'react-i18next'
import { SiteActivityComponent } from 'models/activity'

export interface IContentLayoutProps {
  heading: string
  children?: React.ReactNode
  className?: string
  width?: 'wide' | 'default'
  withPrintButton?: boolean
  printComponent?: SiteActivityComponent
  printElementId?: 'ps_print_click'

}

export const ContentLayout: React.FC<IContentLayoutProps> = (props) => {
  const {
    heading,
    children,
    className,
    width = 'default',
    withPrintButton,
    printComponent,
    printElementId
  } = props

  const handlePrint: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    window.print()
  }

  const WithPrintButton = () => {
    if (!printComponent) {
      return (
        <Button
          className='ds-c-button ds-u-border--0 my-u-no-hover my-u-p--0'
          onClick={handlePrint}
        >
          <span className='ds-u-display--flex ds-u-flex-direction--column ds-u-justify-content--center'>
            <IconPrint className='ds-u-color--base' aria-hidden />
            <span className='my-u-m--0 ds-u-font-size--sm ds-u-text-decoration--none'>
              {t('print')}
            </span>
          </span>
        </Button>
      )
    } else {
      return (
        <Button
          className='ds-c-button ds-u-border--0 my-u-no-hover my-u-p--0'
          onClick={handlePrint}
          siteActivityProps={{
            core: {
              component: printComponent,
              elementId: printElementId,
              coreClickData: {
                linkText: t('print')
              }
            }
          }}
        >
          <span className='ds-u-display--flex ds-u-flex-direction--column ds-u-justify-content--center'>
            <IconPrint className='ds-u-color--base' aria-hidden />
            <span className='my-u-m--0 ds-u-font-size--sm ds-u-text-decoration--none'>
              {t('print')}
            </span>
          </span>
        </Button>
      )
    }
  }

  const { t } = useTranslation('common')
  return (
    <main className={classNames('my-u-content-minheight', 'ds-base', 'my-u-px--4', className)}>
      <div className='ds-l-container'>
        <div className={'ds-l-row my-u-pt--0  my-u-my--20 my-c-main-header-margin' + (width === 'wide' ? '' : ' ds-u-justify-content--center')}>
          {/* TODO-Needs Custom ClassName for Classes passed here */}
          <div className={width === 'default' ? 'ds-l-col--12 ds-l-md-col--10 ds-l-lg-col--8' : 'ds-l-col--12'}>
            <div className='ds-u-display--flex ds-u-justify-content--between'>
              <h1 className='ds-text-heading--3xl ds-u-margin-bottom--2' id={mainHeadingId} tabIndex={-1}>{heading}</h1>
              {withPrintButton && <WithPrintButton/>}
            </div>
            {/* TODO: Remove */}
          {/* <div className={'ds-l-col--12 ds-l-md-col--10 ds-l-lg-col--8' + (alignLeft ? ' my-u-pl--0' : '')}>
            <h1 className='ds-h1 my-u-my--20 my-c-main-header-margin' id={mainHeadingId} tabIndex={-1}>{heading}</h1> */}
          </div>
        </div>
      </div>
      {children}
    </main>
  )
}
